<template>
    <div class="deposit-amount-wrapper" >
        <div class="deposit-desktop d-flex">
            <div class="deposit-desktop__leftpage">
                <div class="deposit-left-side-container">
                    <div class="wallet-no-bx">
                        <div class="deposit-head">
                            <h3>{{$t('deposit','Deposit')}}</h3>
                        </div>
                    </div>
                    <div class="depositNotes">
                        <div class="depositNotes-title">{{$t('notes','Notes')}}</div>
                        <div class="depositNotes-content"><img src="@/assets/images/dashedBorder.webp" alt="dashedBorder"
                                class="depositNotes-content-img">
                            <div class="depositNotes-content-text">{{$t('make-payment-method','Make Payment with Payment methods')}}</div>
                            <div class="depositNotes-content-text">{{$t('copy-utr-12','Copy and Enter the 12 digit UTR Number')}}</div>
                            <div class="screentshot-dposit-banner">
                                <div id="deposit-screenshot-slider-mobile" class="owl-carousel owl-theme">
                                    <div class="item">
                                        <div class="main-slider-img">
                                            <figure><img src="@/assets/images/depositSlide1.webp" alt="depositSlide1"></figure>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="main-slider-img">
                                            <figure><img src="@/assets/images/depositSlide2.webp" alt="depositSlide2"></figure>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="main-slider-img">
                                            <figure><img src="@/assets/images/depositSlide3.webp" alt="depositSlide3"></figure>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="main-slider-img">
                                            <figure><img src="@/assets/images/depositSlide4.webp" alt="depositSlide4"></figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <TutorialVideo type = "2"/>
            </div>
            <div class="deposit-desktop__rightpage desktop-wallet-inst-wrapper">
                <div class="deposit-right-side-container deposit-amount-container ">
                    <div class="container">
                        <div class="amount-sec">
                            <div class="deposit total-amount">
                                <label class="form-label">{{$t('deposit-amount','Deposit Amount*')}}</label>
                                <div class="deposit-amountInput">
                                    <input type="number" v-model="depositAmount" @input="depositAmount = $helper.sanitizeNumber(depositAmount, walletConfig?.deposit_range?.max || 99999999)" class="enter-amount-box">
                                    <!-- <span class="deposit-amountInput-currency"><span class="fa fa-edit"></span> Edit </span> -->
                                    <span class="text-danger mt-2 error-messages-text" v-if="v$.depositAmount.$error">{{$t('please-enter-amount','Please Enter Amount')}}</span>
                                </div>
                                <span class="amount-limit">{{ $t('min', 'Min') }} : {{ walletConfig?.deposit_range?.min ? walletConfig?.deposit_range?.min : 100 }} | {{ $t('max', 'Max') }} : {{ walletConfig?.deposit_range?.max ? walletConfig?.deposit_range?.max : 99999999 }}</span>
                                <div class="grid-container grid-container-three" v-if="walletStake">
                                    <template v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes] : walletConfig?.stake_button)" :key="index">
                                        <button @click="setStakeValue(stake)" class="grid-item">+{{stake }}</button>
                                    </template>
                                </div>
                                <div class="proceed-btn">
                                    <button type="button" @click="openEditStakeModal()"><span class="fa fa-edit"></span>  {{$t('edit-stake','Edit Stake')}}</button>
                                    <button type="button" @click="callForDepositMethods" :class="{ 'disabled': depositAmount < walletConfig?.deposit_range?.min }" :disabled="depositAmount < walletConfig?.deposit_range?.min">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wallet-inst-video-sec">
                    <WalletInstructionVideos/>
                </div>
            </div>
        </div>
    </div>

    <div class="deposit-and-withdrawal-sec  mobile-amount-wrapper">
    <!-- <div class="deposit-and-withdrawal-sec  mobile-amount-wrapper" v-if="this.$helper.isMobile()"> -->
        <div class="container">
            <div class="deposit total-amount mt-1 depo_amount_wrapper">
                <div class="d-flex justify-content-between" >
                    <div class="deposit__title">{{$t('deposit-amount','Deposit Amount')}}</div>
                    <span class="amount-limit">{{$t('less','Min')}} : {{ walletConfig?.deposit_range?.min ? walletConfig?.deposit_range?.min : 100 }} | {{$t('max','Max')}} : {{ walletConfig?.deposit_range?.max ? walletConfig?.deposit_range?.max : 99999999 }}</span>
                </div>
                <div class="deposit-amountInput">
                    <input type="number" v-model="depositAmount" @input="depositAmount = $helper.sanitizeNumber(+depositAmount, +walletConfig?.deposit_range?.max || 99999999)" :placeholder="$t('enter-deposit-amount','Enter Deposit Amount')"
                        class="enter-amount-box">
                    <!-- <span class="deposit-amountInput-currency"><span class="fa fa-edit"></span> Edit</span> -->
                    <span class="text-danger mt-2 error-messages-text" v-if="v$.depositAmount.$error">{{$t('please-enter-amount','Please Enter Amount')}}</span>
                </div>
                <div class="grid-container" v-if="walletStake">
                    <template v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes] : walletConfig?.stake_button)" :key="index">
                        <button @click="setStakeValue(stake)" class="grid-item">+{{stake }}</button>
                    </template>
                </div>
                <div class="proceed-btn depo_edit_save_btn">
                    <button type="button" @click="openEditStakeModal()"><span class="fa fa-edit"></span>{{$t('edit-stake','Edit Stake')}}</button>
                    <button type="button" @click="callForDepositMethods" :class="{ 'disabled': depositAmount < walletConfig?.deposit_range?.min }" :disabled="depositAmount < walletConfig?.deposit_range?.min">{{$t('submit','Submit')}}</button>
                </div>
                <TutorialVideo type = "2"/>
            </div>
        </div>
        <template v-if="!isAllEmpty && availableLanguages.length">
            <div class="guidePoint-details" >
                <ul class="nav nav-pills mb-2" id="pills-tab" role="tablist">
                    <template v-for="lang in availableLanguages" :key="lang">
                        <li class="nav-item" role="presentation">
                        <button class="nav-link" :class="{ active: lang === currentLanguage }" :id="`pills-${lang}-tab`" data-bs-toggle="pill"
                            :data-bs-target="`#pills-${lang}`"  type="button"  role="tab"  :aria-controls="`pills-${lang}`" :aria-selected="lang === currentLanguage"  @click="selectedLanguage = lang">
                            {{ lang }}
                        </button>
                        </li>
                    </template>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                <template v-for="lang in availableLanguages" :key="lang">
                    <div class="tab-pane fade show active" v-show="lang === currentLanguage" :id="`pills-${lang}`" role="tabpanel" :aria-labelledby="`pills-${lang}-tab`">
                    <div v-for="point in walletConfig.rules.deposit[lang]" :key="point.description">
                        <div class="guide-list" v-html="point?.description"></div>
                    </div>
                    <div class="text-center" v-if="walletConfig.rules.deposit[lang].length === 0">
                        {{ $t('no-data-found','No Data found!')}}
                    </div>
                    </div>
                </template>
                </div>
            </div>
        </template>
        <section class="sub-header-wrapper" v-else>
            <div class="sub-header-tab pt-1 sub-header-tab-new">
                <div class="container">
                    <ul class="nav nav-pills" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" :id="`pills-general-tab`" data-bs-toggle="pill" :data-bs-target="`#pills-general`"
                                type="button" role="tab" :aria-controls="`pills-general`" aria-selected="true" >
                                {{$t('general-rules','General rules')}}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="sub-header-tab-con wallet-general-rule-container">
                <div class="container">
                    <div class="tab-content" id="pills-tabContent">
                        <div  class="tab-pane fade show active general-rule-warpper" :id="`pills-general`" role="tabpanel" :aria-labelledby="`pills-general-tab`">
                            <div class="language-list">
                                <p>{{ $t('deposit-money-only-in-the-below-available', 'Deposit money only in the below available accounts to get the fastest credits and avoid possible delays') }}.</p>
                            </div>  
                            <div class="language-list">
                                <p>{{ $t('deposit-money-only-in-the-below-available', 'Deposit money only in the below available accounts to get the fastest credits and avoid possible delays') }}.</p>
                            </div>  
                            <div class="language-list">
                                <p>{{ $t('deposits-made-45-minutes-after-the-account', 'Deposits made 45 minutes after the account removal from the site are valid & will be added to their wallets') }}.</p>
                            </div>
                            <div class="language-list">
                                <p>{{ $t('site-is-not-responsible-for-money', 'Site is not responsible for money deposited to Old, Inactive or Closed accounts') }}.</p>
                            </div>
                            <div class="language-list">
                                <p>{{ $t('after-deposit-add-your-utr-and-amount', 'After deposit, add your UTR and amount to receive balance') }}.</p>
                            </div>
                            <div class="language-list">
                                <p>{{ $t('neft-receiving-time-varies', 'NEFT receiving time varies from 40 minutes to 2 hours') }}.</p>
                            </div>
                            <div class="language-list">
                                <p>{{ $t('in-case-of-account-modification', 'In case of account modification: payment valid for 1 hour after changing account details in deposit page') }}.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <LanguageModal />
    <StakeModal :stakes="walletStake" v-if="walletStake" @updateStakes="saveButtonClick"/>
    <div class="mobile-videio-sec">
        <WalletInstructionVideos/>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { 
    setWalletStakeValue, ocrCheck
} from '@template/utils';
import { mapGetters } from 'vuex';
import LanguageModal from '../components/LanguageModal.vue';
import StakeModal from '../components/StakeModal.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WalletInstructionVideos from '../components/WalletInstructionVideos.vue';
export default {
    name: "WalletDeposit",
    inject: ['walletConfig'],
    extends: ocrCheck,
    setup() {
        return { v$: useVuelidate() }
    },
    components: {
        LanguageModal,
        StakeModal,
        TutorialVideo,
        WalletInstructionVideos
    },
    data() {
        return {
            depositAmount: null,
            walletStake:null,
            activeLanguage: null,
            selectedLanguage: null
        }
    },
    validations: {
        depositAmount: { required }
    },
    computed: {
        chips() {
            return this.$store.getters.chips;
        },
        isAllEmpty() {
            const deposit = this.walletConfig?.rules?.deposit;
            return Object.values(deposit).every(arr => arr.length === 0);
        },
        availableLanguages() {
            const deposit = this.walletConfig?.rules?.deposit || {};
            return Object.keys(deposit).filter(lang => deposit[lang]?.length > 0);
        },
        currentLanguage() {
            return this.availableLanguages.includes(this.selectedLanguage)
            ? this.selectedLanguage
            : this.availableLanguages[0] || null;
        },
        ...mapGetters(['userTransactionStakes'])
    },
    mounted() {
        this.getWalletLimits()
        const messages = this.walletConfig?.rules?.deposit;
        if (messages) {
            this.activeLanguage = Object.keys(messages)[0];
        }
    },
    methods: {
        scrollToref(element) {
            setTimeout(() => {
                element.scrollIntoView({ 
                    behavior: "smooth", 
                    inline: "nearest",
                    block: "end"
                });
            }, 200) 
        },
        setStakeValue(stake) {
            try {
                const response =  setWalletStakeValue(stake, this.depositAmount, this.walletConfig)
                if(response){
                    this.depositAmount =  response; 
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
        callForDepositMethods() {
            this.v$.$touch()
            if (this.v$.$error) {
                console.log(this.v$.$error)
                return
            } else {
                if (!this.depositAmount || this.depositAmount < this.walletConfig?.deposit_range?.min) {
                    this.$errorToast('Please enter amount greter than equal to ' + this.walletConfig?.deposit_range?.min);
                } else {
                    this.$store.dispatch('setDepositAmount', this.depositAmount);
                    this.$router.push({ name: 'deposit-payment' })
                }
            }
        },
        getWalletLimits() {
            this.walletStake = this.walletConfig?.stake_button;
            if(!this.walletStake) {
                this.initializeStake();
            } 
        },
        openEditStakeModal() {
            this.$helper.openModal('#singlestakeeditModal');
        },
        saveButtonClick(stakes) {
            this.walletStake = stakes;
        },
        initializeStake(){
            if (!this.walletStake) {
                this.walletStake = {};
            }
            this.walletStake = {
                stake1 : 100,
                stake2 : 500,
                stake3 : 1000,
                stake4 : 2000,
            };
        }
    }
}
</script>
<style scoped>
.disabled {
    pointer-events: none;
    opacity: 0.5;
}
</style>
<style>
.payment-gateway-sec {
    display: flex;
    flex-direction: column;
    text-align: center;
}

.pg-btn {
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>